import {controller, target, targets} from '@github/catalyst'
import type AffectedProductRowElement from './affected-product-row-element'
import {TemplateInstance} from '@github/template-parts'

@controller('affected-product-list')
export default class AffectedProductListElement extends HTMLElement {
  @target declare rowTemplate: HTMLTemplateElement
  @target declare body: HTMLElement
  @targets declare rows: AffectedProductRowElement[]

  connectedCallback() {
    this.nextIndex = this.rows.length
  }

  // Works like the primary key of a database table. Used to populate the index
  // of the fields in a new entry. Keeps incrementing for each new row that is
  // added. Value does not decrease to prevent conflict with last existing entry
  // when preceding rows might have been removed.
  get nextIndex(): number {
    const index = this.getAttribute('data-next-index')
    if (index === null) {
      return 0
    }
    return parseInt(index, 10)
  }

  set nextIndex(newIndex: number) {
    this.setAttribute('data-next-index', newIndex.toString())
  }

  addRow() {
    this.body.appendChild(new TemplateInstance(this.rowTemplate, {'affected-product-entry-index': this.nextIndex}))
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const newRow = this.rows[this.rows.length - 1]!
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const precedingRow = this.rows[this.rows.length - 2]!
    newRow.ecosystem = precedingRow.ecosystem
    newRow.ecosystemOther = precedingRow.ecosystemOther
    newRow.package = precedingRow.package
    newRow.focusFirstInput()
    this.nextIndex++
    this.dispatchChangeEvent()
  }

  removeRow(event: Event) {
    const row = (event as CustomEvent).detail
    if (this.rows.length === 1) {
      row.clear()
    } else {
      if (this.getAttribute('data-destroy-entries') !== null) {
        row.markToDestroy()
        row.hide()
        row.removeAttribute('data-targets')
      } else {
        row.remove()
      }
    }
    this.dispatchChangeEvent()
  }

  dispatchChangeEvent() {
    this.dispatchEvent(new CustomEvent('affected-product-list-change', {bubbles: true}))
  }
}
